import { render, staticRenderFns } from "./viewRedBlack.vue?vue&type=template&id=4e69a024&scoped=true&"
import script from "./viewRedBlack.vue?vue&type=script&lang=js&"
export * from "./viewRedBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e69a024",
  null
  
)

export default component.exports